import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl-next';

import Button from '@atlaskit/button/new';
import EmptyState from '@atlaskit/empty-state';

import { messages } from '../i18n';
import AccessLockSVG from '../icons/AccessLockSVG';

import { AccessLockSVGWrapper, ActionButtonWrapper } from './styled';

const NoAccessErrorState = ({ onAction }: { onAction: () => void }): React.JSX.Element => {
	const intl = useIntl();

	const action = (
		<ActionButtonWrapper>
			<Button onClick={onAction} appearance="primary">
				<FormattedMessage {...messages.noAccessErrorStateActionLabel} />
			</Button>
		</ActionButtonWrapper>
	);

	return (
		<EmptyState
			header={intl.formatMessage(messages.noAccessErrorStateTitle)}
			description={intl.formatMessage(messages.noAccessErrorStateMessage)}
			primaryAction={action}
			renderImage={() => (
				<AccessLockSVGWrapper>
					<AccessLockSVG />
				</AccessLockSVGWrapper>
			)}
		/>
	);
};

export default NoAccessErrorState;
